import _ from 'underscore';
import Backbone from '@trello/backbone';

import type {
  RpcModelType,
  RpcUpdatePayload,
  RpcDeletePayload,
} from './rpc.types';

type BackboneEvents = typeof Backbone.Events;
interface RpcEvents extends BackboneEvents {
  on(type: 'updateModels', callback: (payload: RpcUpdatePayload) => void): this;
  on(type: 'deleteModels', callback: (payload: RpcDeletePayload) => void): this;
  on(
    type: 'invalidModel',
    callback: (typeName: RpcModelType, id: string) => void,
  ): this;
  on(
    type:
      | 'ready'
      | 'subscription_invalid'
      | 'connect_failed'
      | 'reconnect_failed',
    callback: () => void,
  ): this;
  off(
    type: 'updateModels',
    callback: (payload: RpcUpdatePayload) => void,
  ): this;
  trigger(
    name:
      | 'connect'
      | 'connecting'
      | 'connect_failed'
      | 'ready'
      | 'reconnect'
      | 'reconnect_failed'
      | 'disconnect'
      | 'invalidModel'
      | 'subscription_invalid',
    data?: object | string,
    idModel?: string,
    tags?: string[],
  ): this;
}

export const rpcEvents: RpcEvents = _.extend({}, Backbone.Events);
